import { DBCommand } from "src/app/shared/models/domain/dbcommand";
import { FileTransfer } from "src/app/shared/models/stream/jobs/filetransfer";
import { RestJob } from "src/app/shared/models/domain/restjob";
import { Office365 } from "src/app/shared/models/domain/office365";
import { JsonC } from "src/app/shared/models/domain/jsonc"; //add by sharmi 0n 4-3-25
import { CobolConverter } from "src/app/shared/models/domain/cobolconverter";
import { GPS } from "src/app/shared/models/domain/gps";
import { MongoDB } from "src/app/shared/models/domain/mongodb";
import { Hbase } from "src/app/shared/models/domain/hbase";
import { DesignJob } from "src/app/shared/models/domain/designjob";
import { TaskEmail } from "src/app/shared/models/domain/task_email";
import { LoopStart } from "src/app/shared/models/domain/loopstart";
import { LoopEnd } from "src/app/shared/models/domain/loopend";
import { HdfsCommand } from "src/app/shared/models/domain/hdfscommand";
import { DxFlow_Fwd_Lnk } from "src/app/shared/models/domain/dxflow_fwd_lnk";
import { TaskCommand } from "src/app/shared/models/domain/taskcommand";
import { ObjectWrapper } from "src/app/shared/wrappers/object.wrapper";
import { StreamWrapper } from "../stream.wrapper";
import { JobWrapper } from "./job.wrapper";
import { Util } from "src/app/shared/utils/util";
import { Stream } from "src/app/shared/models/domain/stream";
import { ObjectWrapperUtil } from "src/app/shared/utils/object.wrapper.util";
import { KafkaProducerJob } from "src/app/shared/models/domain/kafkaproducer";
import { KafkaConsumer } from "src/app/shared/models/domain/kafkaconsumer";
import { GpsSubscriber } from "src/app/shared/models/domain/googlesubscriber";
export class JobsUtil {
  private static instance: JobsUtil;

  static getInstance() {
    if (!JobsUtil.instance) {
      JobsUtil.instance = new JobsUtil();
    }

    return JobsUtil.instance;
  }

  /**
   * JobsUtil is a singleton class, so use JobsUtil.getInstance() method instead of creating new JobsUtil().
   */
  private constructor() {}

  isDuplicateLink(
    fromJob_Id: number,
    toJob_Id: number,
    dxFlow_Fwd_Lnks: Array<DxFlow_Fwd_Lnk>,
  ): boolean {
    for (let i: number = 0; i < dxFlow_Fwd_Lnks.length; i++) {
      let dxFlow_Fwd_Lnk: DxFlow_Fwd_Lnk = dxFlow_Fwd_Lnks[i];

      if (
        dxFlow_Fwd_Lnk.obj_Id == fromJob_Id &&
        dxFlow_Fwd_Lnk.fwd_Lnk_Obj_Id == toJob_Id
      )
        return true;
    }
  }

  isCircularLink(
    fromJob_Id: number,
    toJob_Id: number,
    dxFlow_Fwd_Lnks: Array<DxFlow_Fwd_Lnk>,
  ): boolean {
    if (fromJob_Id == toJob_Id) return true;

    var preceedingJob_Ids = [];
    this._getPreceedingJob_Ids(fromJob_Id, dxFlow_Fwd_Lnks, preceedingJob_Ids);
    if (preceedingJob_Ids.indexOf(toJob_Id) != -1) return true;

    /*preceedingJob_Ids = [];
        factoryObj.getPreceedingJob_Ids( toJob_Id, dxFlow_Fwd_Lnks, preceedingJob_Ids );
        if( preceedingJob_Ids.indexOf(fromJob_Id) != -1 ) return true;*/

    return false;
  }

  private _getPreceedingJob_Ids(
    job_Id: number,
    dxFlow_Fwd_Lnks: Array<DxFlow_Fwd_Lnk>,
    preceedingJob_Ids: Array<number>,
  ): void {
    preceedingJob_Ids.push(job_Id);

    for (let i: number = 0; i < dxFlow_Fwd_Lnks.length; i++) {
      if (dxFlow_Fwd_Lnks[i].fwd_Lnk_Obj_Id != job_Id) continue;
      this._getPreceedingJob_Ids(
        dxFlow_Fwd_Lnks[i].obj_Id,
        dxFlow_Fwd_Lnks,
        preceedingJob_Ids,
      );
    }
  }

  copy(jobs: Array<any>): Array<any> {
    let jobsTmp: Array<any> = new Array<any>();

    for (let i: number = 0; i < jobs.length; i++) {
      jobsTmp.push(jobs[i].copy());
    }

    return jobsTmp;
  }

  copyFrom(jobs: Array<any>, jobsTmp: Array<any>): void {
    let jobsMap: Map<number, any> = new Map<number, any>();

    for (let i: number = 0; i < jobs.length; i++) {
      jobsMap.set(this.getJob_Id(jobs[i]), jobs[i]);
    }
    jobs.splice(0, jobs.length);

    for (let i: number = 0; i < jobsTmp.length; i++) {
      let jobTmp: any = jobsTmp[i];

      let job: any = jobsMap.get(this.getJob_Id(jobTmp));
      if (job) {
        this.copyFromJob(job, jobTmp);
      } else {
        job = this.copyJob(jobTmp);
      }

      jobs.push(job);
    }
  }

  getJob_Id(job: any): number {
    if (job.hasOwnProperty("dxMp_Inst")) {
      return job.dxMp_Inst.dxMp_Inst_Id;
    }

    if (job.hasOwnProperty("dCmd_Inst")) {
      return job.dCmd_Inst.dCmd_Inst_Id;
    }

    if (job.hasOwnProperty("tCmd_Inst")) {
      return job.tCmd_Inst.tCmd_Inst_Id;
    }

    if (job.hasOwnProperty("hdfsCmd_Inst")) {
      return job.hdfsCmd_Inst.hdfsCmd_Inst_Id;
    }

    if (job.hasOwnProperty("kafkaConsumer_Inst")) {
      return job.kafkaConsumer_Inst.kafkaconsumer_inst_id;
    }
    if (job.hasOwnProperty("gpsSubscriber_Inst")) {
      return job.gpsSubscriber_Inst.gpsSubscriber_inst_id;
    }

    if (job.hasOwnProperty("looper")) {
      return job.looper.looper_Id;
    }

    if (job.hasOwnProperty("looper_End")) {
      return job.looper_End.looper_End_Id;
    }

    if (job.hasOwnProperty("tEmail_Inst")) {
      return job.tEmail_Inst.tEmail_Inst_Id;
    }

    if (job.hasOwnProperty("fileTransfer_Inst")) {
      return job.fileTransfer_Inst.fileTransfer_Inst_Id;
    }

    if (job.hasOwnProperty("restJob_Inst")) {
      return job.restJob_Inst.restJob_Inst_Id;
    }

    if (job.hasOwnProperty("kafkaProducerJob_Inst")) {
      return job.kafkaProducerJob_Inst.kafkaproducer_inst_id;
    }

    if (job.hasOwnProperty("office365_Inst")) {
      return job.office365_Inst.office365_Inst_Id;
    }

    //add by sharmi 0n 4-3-25
    if (job.hasOwnProperty("jsonC_Inst")) {
      return job.jsonC_Inst.jsonc_Inst_Id;
    }

    if (job.hasOwnProperty("cobolConverter_Inst")) {
      return job.cobolConverter_Inst.cobolConverter_Inst_Id;
    }

    if (job.hasOwnProperty("gps_Inst")) {
      return job.gps_Inst.gps_Inst_Id;
    }

    if (job.hasOwnProperty("mongoDB_Inst")) {
      return job.mongoDB_Inst.mongoDB_Inst_Id;
    }

    if (job.hasOwnProperty("hbase_Inst")) {
      return job.hbase_Inst.hbase_Inst_Id;
    }

    return -1;
  }

  getJob_Cd(job: any) {
    if (job.hasOwnProperty("dxMp_Inst")) {
      return "DXMPI";
    }
    if (job.hasOwnProperty("dCmd_Inst")) {
      return "DCMD";
    }
    if (job.hasOwnProperty("tCmd_Inst")) {
      return "TCMD";
    }

    if (job.hasOwnProperty("hdfsCmd_Inst")) {
      return "HCMD";
    }

    if (job.hasOwnProperty("kafkaConsumer_Inst")) {
      return "KCJ";
    }
    if (job.hasOwnProperty("gpsSubscriber_Inst")) {
      return "GSJ";
    }

    if (job.hasOwnProperty("looper")) {
      return "LPST";
    }
    if (job.hasOwnProperty("looper_End")) {
      return "LPED";
    }
    if (job.hasOwnProperty("tEmail_Inst")) {
      return "EMNF";
    }
    if (job.hasOwnProperty("fileTransfer_Inst")) {
      return "FTRN";
    }
    if (job.hasOwnProperty("restJob_Inst")) {
      return "RSTJ";
    }
    if (job.hasOwnProperty("kafkaProducerJob_Inst")) {
      return "KPJ";
    }
    if (job.hasOwnProperty("office365_Inst")) {
      return "OFC365J";
    }
    if (job.hasOwnProperty("jsonC_Inst")) {
      //add by sharmi on 4-3-25
      return "JSONCJ";
    }
    if (job.hasOwnProperty("cobolConverter_Inst")) {
      return "CBLCJ";
    }
    if (job.hasOwnProperty("gps_Inst")) {
      return "GS";
    }
    if (job.hasOwnProperty("mongoDB_Inst")) {
      return "MG";
    }
    if (job.hasOwnProperty("hbase_Inst")) {
      return "HB";
    }
    return "";
  }

  copyFromJob(job: any, jobTmp: any): void {
    if (job.hasOwnProperty("dxMp_Inst")) {
      (job as DesignJob).copyFrom(jobTmp as DesignJob);
      return;
    }

    if (job.hasOwnProperty("dCmd_Inst")) {
      (job as DBCommand).copyFrom(jobTmp as DBCommand);
      return;
    }

    if (job.hasOwnProperty("tCmd_Inst")) {
      (job as TaskCommand).copyFrom(jobTmp as TaskCommand);
      return;
    }

    if (job.hasOwnProperty("hdfsCmd_Inst")) {
      (job as HdfsCommand).copyFrom(jobTmp as HdfsCommand);
      return;
    }

    if (job.hasOwnProperty("looper")) {
      (job as LoopStart).copyFrom(jobTmp as LoopStart);
      return;
    }
    if (job.hasOwnProperty("looper_End")) {
      (job as LoopEnd).copyFrom(jobTmp as LoopEnd);
      return;
    }
    if (job.hasOwnProperty("tEmail_Inst")) {
      (job as TaskEmail).copyFrom(jobTmp as TaskEmail);
      return;
    }
    if (job.hasOwnProperty("fileTransfer_Inst")) {
      (job as FileTransfer).copyFrom(jobTmp as FileTransfer);
      return;
    }
    if (job.hasOwnProperty("restJob_Inst")) {
      (job as RestJob).copyFrom(jobTmp as RestJob);
      return;
    }
    if (job.hasOwnProperty("kafkaProducerJob_Inst")) {
      (job as KafkaProducerJob).copyFrom(jobTmp as KafkaProducerJob);
      return;
    }
    if (job.hasOwnProperty("office365_Inst")) {
      (job as Office365).copyFrom(jobTmp as Office365);
      return;
    }
    if (job.hasOwnProperty("kafkaConsumer_Inst")) {
      (job as KafkaConsumer).copyFrom(jobTmp as KafkaConsumer);
      return;
    }
    if (job.hasOwnProperty("gpsSubscriber_Inst")) {
      (job as GpsSubscriber).copyFrom(jobTmp as GpsSubscriber);
      return;
    }

    if (job.hasOwnProperty("jsonC_Inst")) {
      (job as JsonC).copyFrom(jobTmp as JsonC); //add by sharmi on 4-3-25
      return;
    }
    if (job.hasOwnProperty("cobolConverter_Inst")) {
      (job as CobolConverter).copyFrom(jobTmp as CobolConverter);
      return;
    }
    if (job.hasOwnProperty("gps_Inst")) {
      (job as GPS).copyFrom(jobTmp as GPS);
      return;
    }
    if (job.hasOwnProperty("mongoDB_Inst")) {
      (job as MongoDB).copyFrom(jobTmp as MongoDB);
      return;
    }
  }

  copyJob(job: any): any {
    if (job.hasOwnProperty("dxMp_Inst")) {
      return DesignJob.parse(job as DesignJob);
    }

    if (job.hasOwnProperty("dCmd_Inst")) {
      return DBCommand.parse(job as DBCommand);
    }

    if (job.hasOwnProperty("tCmd_Inst")) {
      return TaskCommand.parse(job as TaskCommand);
    }

    if (job.hasOwnProperty("hdfsCmd_Inst")) {
      return HdfsCommand.parse(job as HdfsCommand);
    }

    if (job.hasOwnProperty("looper")) {
      return LoopStart.parse(job as LoopStart);
    }
    if (job.hasOwnProperty("looper_End")) {
      return LoopEnd.parse(job as LoopEnd);
    }
    if (job.hasOwnProperty("tEmail_Inst")) {
      return TaskEmail.parse(job as TaskEmail);
    }
    if (job.hasOwnProperty("fileTransfer_Inst")) {
      return FileTransfer.parse(job as FileTransfer);
    }
    if (job.hasOwnProperty("restJob_Inst")) {
      return RestJob.parse(job as RestJob);
    }
    if (job.hasOwnProperty("kafkaProducerJob_Inst")) {
      return KafkaProducerJob.parse(job as KafkaProducerJob);
    }
    if (job.hasOwnProperty("office365_Inst")) {
      return Office365.parse(job as Office365);
    }
    if (job.hasOwnProperty("kafkaConsumer_Inst")) {
      return KafkaConsumer.parse(job as KafkaConsumer);
    }

    if (job.hasOwnProperty("gpsSubscriber_Inst")) {
      return GpsSubscriber.parse(job as GpsSubscriber);
    }
    if (job.hasOwnProperty("jsonC_Inst")) {
      //add by sharmi on 4-3-25
      return JsonC.parse(job as JsonC);
    }
    if (job.hasOwnProperty("cobolConverter_Inst")) {
      return CobolConverter.parse(job as CobolConverter);
    }
    if (job.hasOwnProperty("gps_Inst")) {
      return GPS.parse(job as GPS);
    }
    if (job.hasOwnProperty("mongoDB_Inst")) {
      return MongoDB.parse(job as MongoDB);
    }
    if (job.hasOwnProperty("hbase_Inst")) {
      return Hbase.parse(job as Hbase);
    }
  }

  getJob(obj_Id, jobs) {
    for (let i = 0; i < jobs.length; i++) {
      let job = jobs[i];

      if (this.getJob_Id(job) == obj_Id) return job;
    }
    return null;
  }

  getComment(comment_Id, jobFlowCanvasComments) {
    for (let i: number = 0; i < jobFlowCanvasComments.length; i++) {
      let canvasComment = jobFlowCanvasComments[i];

      if (canvasComment.comment_Inst.comment_Inst_Id == comment_Id)
        return canvasComment;
    }
    return null;
  }

  changeLoopEndName(
    name: string,
    objectWrapper: ObjectWrapper,
    oldLooperName: string,
    newLooperName: string,
  ): void {
    let loopStart = objectWrapper.object.looper;

    let streamWrapper: StreamWrapper = objectWrapper.streamWrapper;
    for (let i: number = 0; i < streamWrapper.jobWrappers.length; i++) {
      let jobWrapper: JobWrapper = streamWrapper.jobWrappers[i];
      if (!jobWrapper.hasOwnProperty("loopEnd")) continue;
      if (loopStart.looper_Id != jobWrapper.object.looper_End.looper_Id)
        continue;

      let oldName = jobWrapper.object.looper_End.nm;
      jobWrapper.object.looper_End.nm = name + "_End";
      jobWrapper.name = jobWrapper.object.looper_End.nm;
      jobWrapper.setNameTSpans();
      jobWrapper.object.looper_End.looper_StartNm = name;
      this.linkCondRename(
        oldName,
        jobWrapper.name,
        jobWrapper,
        jobWrapper.streamWrapper,
      );
      jobWrapper.doValidate();
    }
    // this.looperDownstreamReaname(oldLooperName, newLooperName, objectWrapper);
  }

  looperDownstreamReaname(
    oldLooperName: string,
    newLooperName: string,
    objectWrapper: ObjectWrapper,
  ): void {
    let oldName: string = "$LP_" + oldLooperName;
    let newName: string = "$LP_" + newLooperName;

    let oldFullName: string = "LP_" + oldLooperName;
    let newFullName: string = "LP_" + newLooperName;

    this.downStreamRename(
      oldName,
      newName,
      oldFullName,
      newFullName,
      -1,
      -1,
      objectWrapper,
      objectWrapper.streamWrapper,
    );
  }

  downStreamRename(
    oldName: string,
    newName: string,
    oldFullName: string,
    newFullName: string,
    srt_Order: number,
    attr_Id: number,
    jobWrapper: ObjectWrapper,
    streamWrapper: StreamWrapper,
    isJobName: boolean = false,
    paramType: string = "",
  ) {
    let downStreamObj_Ids = new Array<any>();
    let oldFullNameRegexp: any = new RegExp("\\b" + oldFullName + "\\b", "g");
    let obj_Id = -1;

    if (jobWrapper == undefined) {
      downStreamObj_Ids = this.getOrderedJob_Ids(streamWrapper.stream);
    } else {
      this.packDownStreamObj_Ids(
        jobWrapper.obj_Id,
        streamWrapper.stream.dxFlow_Fwd_Lnks,
        downStreamObj_Ids,
      );
      this.applyDownStreamRename(
        oldName,
        newName,
        oldFullName,
        oldFullNameRegexp,
        newFullName,
        srt_Order,
        attr_Id,
        obj_Id,
        jobWrapper,
        isJobName,
        paramType,
      );
      obj_Id = jobWrapper.obj_Id;
    }

    /*factoryObj.linkCondRename(oldName, newName, jobWrapper, streamWrapper)*/

    for (
      let i: number = 0;
      i < streamWrapper.stream.dxFlow_Fwd_Lnks.length;
      i++
    ) {
      let dxFlow_Fwd_Lnk: DxFlow_Fwd_Lnk =
        streamWrapper.stream.dxFlow_Fwd_Lnks[i];
      if (dxFlow_Fwd_Lnk.lnkCndVal.indexOf(oldName) != -1) {
        let name = new RegExp(oldName, "g");
        let linkCnd = dxFlow_Fwd_Lnk.lnkCndVal.replace(name, newName);
        dxFlow_Fwd_Lnk.lnkCndVal = linkCnd;
      }
    }

    srt_Order = -1;

    for (let i: number = 0; i < downStreamObj_Ids.length; i++) {
      let jobWrapperTmp: JobWrapper = streamWrapper.getJobWrapper(
        downStreamObj_Ids[i],
      );
      if (!jobWrapperTmp) continue;

      this.applyDownStreamRename(
        oldName,
        newName,
        oldFullName,
        oldFullNameRegexp,
        newFullName,
        srt_Order,
        attr_Id,
        obj_Id,
        jobWrapperTmp,
        isJobName,
        paramType,
      );
    }

    if (jobWrapper == null) {
      var name: any;
      for (let i: number = 0; i < streamWrapper.stream.sqlParams.length; i++) {
        var sqlParam = streamWrapper.stream.sqlParams[i];
        if (sqlParam.paramVal.indexOf(name) == -1) continue;

        sqlParam.paramVal = Util.getInstance().rename(
          sqlParam.paramVal,
          oldFullNameRegexp,
          newFullName,
        );
      }

      streamWrapper.doValidate();
    }
  }

  linkCondRename(
    oldName: string,
    newName: string,
    objectWrapper: ObjectWrapper,
    streamWrapper: StreamWrapper,
  ) {
    let oldFullNameRegexp: any = new RegExp(oldName, "g");
    for (
      let i: number = 0;
      i < streamWrapper.stream.dxFlow_Fwd_Lnks.length;
      i++
    ) {
      let dxFlow_Fwd_Lnk: DxFlow_Fwd_Lnk =
        streamWrapper.stream.dxFlow_Fwd_Lnks[i];
      let _index: number = dxFlow_Fwd_Lnk.lnkCndVal.indexOf("_");
      let subOldName: string = dxFlow_Fwd_Lnk.lnkCndVal.substr(
        _index + 1,
        dxFlow_Fwd_Lnk.lnkCndVal.length,
      );
      let dotIndex: number = subOldName.indexOf(".");
      let fullName: string = subOldName.substr(0, dotIndex);

      // if (fullName == oldName) {
      //     let linkCnd = Util.getInstance().rename(dxFlow_Fwd_Lnk.lnkCndVal, oldFullNameRegexp, newName, oldName);

      //     dxFlow_Fwd_Lnk.lnkCndVal = linkCnd;
      // }

      if (subOldName.indexOf(oldName) != -1 && fullName != newName) {
        let linkCnd = Util.getInstance().rename(
          dxFlow_Fwd_Lnk.lnkCndVal,
          oldFullNameRegexp,
          newName,
          oldName,
        );

        dxFlow_Fwd_Lnk.lnkCndVal = linkCnd;
      }
    }
  }

  getOrderedJob_Ids(stream: Stream) {
    this.cleanUpDxMp_Fwd_Lnks(stream);

    let job_Ids = new Array<any>();

    let obj_Ids = new Array<any>();
    let fwd_Lnk_Obj_IdsHMap = new Array<any>();

    for (let i: number = 0; i < stream.dxFlow_Fwd_Lnks.length; i++) {
      let dxMp_Fwd_Lnk: DxFlow_Fwd_Lnk = stream.dxFlow_Fwd_Lnks[i];

      if (obj_Ids.indexOf(dxMp_Fwd_Lnk.obj_Id) == -1)
        obj_Ids.push(dxMp_Fwd_Lnk.obj_Id);

      let object = fwd_Lnk_Obj_IdsHMap[dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id];
      if (!object) {
        object = {};
        object.fwd_Lnk_Obj_Id = dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id;
        object.obj_Ids = [];

        fwd_Lnk_Obj_IdsHMap[object.fwd_Lnk_Obj_Id] = object;
      }

      object.obj_Ids.push(dxMp_Fwd_Lnk.obj_Id);
    }

    for (var i = 0; i < stream.objects.length; i++) {
      var job_Id = this.getJob_Id(stream.objects[i]);

      if (obj_Ids.indexOf(job_Id) == -1) {
        this.recursionOrderedJob_Ids(job_Id, fwd_Lnk_Obj_IdsHMap, job_Ids);
      }
    }

    return job_Ids;
  }

  packDownStreamObj_Ids(
    job_Id: number,
    dxFlow_Fwd_Lnks: Array<any>,
    downStreamObj_Ids: Array<any>,
  ) {
    for (let i: number = 0; i < dxFlow_Fwd_Lnks.length; i++) {
      let dxFlow_Fwd_Lnk: DxFlow_Fwd_Lnk = dxFlow_Fwd_Lnks[i];

      if (dxFlow_Fwd_Lnk.obj_Id == job_Id) {
        downStreamObj_Ids.push(dxFlow_Fwd_Lnk.fwd_Lnk_Obj_Id);
        this.packDownStreamObj_Ids(
          dxFlow_Fwd_Lnk.fwd_Lnk_Obj_Id,
          dxFlow_Fwd_Lnks,
          downStreamObj_Ids,
        );
      }
    }
  }

  recursionOrderedJob_Ids(
    job_Id: number,
    fwd_Lnk_Obj_IdsHMap: Array<any>,
    job_Ids: Array<any>,
  ) {
    job_Ids.splice(0, 0, job_Id);

    let object = fwd_Lnk_Obj_IdsHMap[job_Id];
    if (object) {
      for (let i: number = 0; i < object.obj_Ids.length; i++) {
        let obj_Id: number = object.obj_Ids[i];
        let index: number = job_Ids.indexOf(obj_Id);

        if (index != -1) job_Ids.splice(index, 1);

        this.recursionOrderedJob_Ids(obj_Id, fwd_Lnk_Obj_IdsHMap, job_Ids);
      }
    }
  }

  cleanUpDxMp_Fwd_Lnks(stream: Stream): void {
    let job_Ids = new Array<any>();
    for (let i: number = 0; i < stream.objects.length; i++) {
      job_Ids.push(this.getJob_Id(stream.objects[i]));
    }

    for (let i: number = 0; i < stream.dxFlow_Fwd_Lnks.length; i++) {
      let dxMp_Fwd_Lnk = stream.dxFlow_Fwd_Lnks[i];
      if (
        job_Ids.indexOf(dxMp_Fwd_Lnk.obj_Id) == -1 ||
        job_Ids.indexOf(dxMp_Fwd_Lnk.fwd_Lnk_Obj_Id) == -1
      ) {
        stream.dxFlow_Fwd_Lnks.splice(i, 1);
        i--;
      }
    }
  }

  applyDownStreamRename(
    oldName: string,
    newName: string,
    oldFullName: string,
    oldFullNameRegexp: any,
    newFullName: string,
    srt_Order: number,
    attr_Id: number,
    obj_Id,
    jobWrapper: ObjectWrapper,
    isJobName: boolean = false,
    paramType: string,
  ) {
    if (srt_Order == -1 || srt_Order == undefined) srt_Order = 0;

    if (jobWrapper.hasOwnProperty("taskCommand")) {
      if (jobWrapper.object.tCmd_Inst.tCmdScriptNm.indexOf(oldFullName) != -1) {
        if (paramType && paramType == "RT") {
          let val = jobWrapper.object.tCmd_Inst.tCmdScriptNm
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.tCmd_Inst.tCmdScriptNm = val;
        } else {
          var tCmdScriptNm = jobWrapper.object.tCmd_Inst.tCmdScriptNm;
          jobWrapper.object.tCmd_Inst.tCmdScriptNm = Util.getInstance().rename(
            jobWrapper.object.tCmd_Inst.tCmdScriptNm,
            oldFullNameRegexp,
            newFullName,
          );
          if (tCmdScriptNm == jobWrapper.object.tCmd_Inst.tCmdScriptNm) {
            var val = jobWrapper.object.tCmd_Inst.tCmdScriptNm
              .split(oldFullName)
              .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
            jobWrapper.object.tCmd_Inst.tCmdScriptNm = val;
          }
        }
      }
    }

    if (jobWrapper.hasOwnProperty("dbCommand")) {
      if (jobWrapper.object.dCmd_Inst.dCmd.indexOf(oldFullName) != -1) {
        if (paramType && paramType == "RT") {
          let val = jobWrapper.object.dCmd_Inst.dCmd
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.dCmd_Inst.dCmd = val;
        } else {
          let dCmd = jobWrapper.object.dCmd_Inst.dCmd;
          jobWrapper.object.dCmd_Inst.dCmd = Util.getInstance().rename(
            jobWrapper.object.dCmd_Inst.dCmd,
            oldFullNameRegexp,
            newFullName,
          );
          if (dCmd == jobWrapper.object.dCmd_Inst.dCmd) {
            let val = jobWrapper.object.dCmd_Inst.dCmd
              .split(oldFullName)
              .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
            jobWrapper.object.dCmd_Inst.dCmd = val;
          }
        }
      }

      if (jobWrapper.object.dCmd_Inst.outPutFile.indexOf(oldFullName) != -1) {
        if (paramType && paramType == "RT") {
          let val = jobWrapper.object.dCmd_Inst.outPutFile
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.dCmd_Inst.outPutFile = val;
        } else {
          let outPutFile = jobWrapper.object.dCmd_Inst.outPutFile;
          jobWrapper.object.dCmd_Inst.outPutFile = Util.getInstance().rename(
            jobWrapper.object.dCmd_Inst.outPutFile,
            oldFullNameRegexp,
            newFullName,
          );
          if (outPutFile == jobWrapper.object.dCmd_Inst.outPutFile) {
            let val = jobWrapper.object.dCmd_Inst.outPutFile
              .split(oldFullName)
              .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
            jobWrapper.object.dCmd_Inst.outPutFile = val;
          }
        }
      }
    }

    if (jobWrapper.hasOwnProperty("hdfsCommand")) {
      if (jobWrapper.object.hdfsCmd_Inst.hdfsCmd.indexOf(oldFullName) != -1) {
        if (paramType && paramType == "RT") {
          let val = jobWrapper.object.hdfsCmd_Inst.hdfsCmd
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.hdfsCmd_Inst.hdfsCmd = val;
        } else {
          let hdfsCmd = jobWrapper.object.hdfsCmd_Inst.hdfsCmd;
          jobWrapper.object.hdfsCmd_Inst.hdfsCmd = Util.getInstance().rename(
            jobWrapper.object.hdfsCmd_Inst.hdfsCmd,
            oldFullNameRegexp,
            newFullName,
          );
          if (hdfsCmd == jobWrapper.object.hdfsCmd_Inst.hdfsCmd) {
            let val = jobWrapper.object.hdfsCmd_Inst.hdfsCmd
              .split(oldFullName)
              .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
            jobWrapper.object.hdfsCmd_Inst.hdfsCmd = val;
          }
        }
      }
    }

    if (jobWrapper.hasOwnProperty("looper")) {
      if (jobWrapper.object.looper.itrVal.indexOf(oldFullName) != -1) {
        if (paramType && paramType == "RT") {
          let val = jobWrapper.object.looper.itrVal
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.looper.itrVal = val;
        } else {
          let itrVal = jobWrapper.object.looper.itrVal;

          jobWrapper.object.looper.itrVal = Util.getInstance().rename(
            jobWrapper.object.looper.itrVal,
            oldFullNameRegexp,
            newFullName,
          );
          if (itrVal == jobWrapper.object.looper.itrVal) {
            var val = jobWrapper.object.looper.itrVal
              .split(oldFullName)
              .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
            jobWrapper.object.looper.itrVal = val;
          }
        }
      }
    }

    if (jobWrapper.hasOwnProperty("taskEmail")) {
      if (jobWrapper.object.tEmail_Inst.message.indexOf(oldFullName) != -1) {
        if (paramType && paramType == "RT") {
          let val = jobWrapper.object.tEmail_Inst.message
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.tEmail_Inst.message = val;
        } else {
          let message = jobWrapper.object.tEmail_Inst.message;
          jobWrapper.object.tEmail_Inst.message = Util.getInstance().rename(
            jobWrapper.object.tEmail_Inst.message,
            oldFullNameRegexp,
            newFullName,
          );
          if (message == jobWrapper.object.tEmail_Inst.message) {
            let val = jobWrapper.object.tEmail_Inst.message
              .split(oldFullName)
              .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
            jobWrapper.object.tEmail_Inst.message = val;
          }
        }
      }
      //DDS-5324
      if (jobWrapper.object.tEmail_Inst.email_To.indexOf(oldFullName) != -1) {
        if (paramType && paramType == "RT") {
          let val = jobWrapper.object.tEmail_Inst.email_To
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.tEmail_Inst.email_To = val;
        } else {
          let email_To = jobWrapper.object.tEmail_Inst.email_To;

          jobWrapper.object.tEmail_Inst.email_To = Util.getInstance().rename(
            jobWrapper.object.tEmail_Inst.email_To,
            oldFullNameRegexp,
            newFullName,
          );

          if (email_To == jobWrapper.object.tEmail_Inst.email_To) {
            let val = jobWrapper.object.tEmail_Inst.email_To
              .split(oldFullName)
              .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
            jobWrapper.object.tEmail_Inst.email_To = val;
          }
        }
      }

      if (jobWrapper.object.tEmail_Inst.email_Cc.indexOf(oldFullName) != -1) {
        if (paramType && paramType == "RT") {
          let val = jobWrapper.object.tEmail_Inst.email_Cc
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.tEmail_Inst.email_Cc = val;
        } else {
          let email_Cc = jobWrapper.object.tEmail_Inst.email_Cc;

          jobWrapper.object.tEmail_Inst.email_Cc = Util.getInstance().rename(
            jobWrapper.object.tEmail_Inst.email_Cc,
            oldFullNameRegexp,
            newFullName,
          );
          if (email_Cc == jobWrapper.object.tEmail_Inst.email_Cc) {
            let val = jobWrapper.object.tEmail_Inst.email_Cc
              .split(oldFullName)
              .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
            jobWrapper.object.tEmail_Inst.email_Cc = val;
          }
        }
      }

      if (jobWrapper.object.tEmail_Inst.subject.indexOf(oldFullName) != -1) {
        if (paramType && paramType == "RT") {
          let val = jobWrapper.object.tEmail_Inst.subject
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.tEmail_Inst.subject = val;
        } else {
          let subject = jobWrapper.object.tEmail_Inst.subject;

          jobWrapper.object.tEmail_Inst.subject = Util.getInstance().rename(
            jobWrapper.object.tEmail_Inst.subject,
            oldFullNameRegexp,
            newFullName,
          );
          if (subject == jobWrapper.object.tEmail_Inst.subject) {
            let val = jobWrapper.object.tEmail_Inst.subject
              .split(oldFullName)
              .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
            jobWrapper.object.tEmail_Inst.subject = val;
          }
        }
      }
    }

    if (jobWrapper.hasOwnProperty("designJob")) {
      for (var i = srt_Order; i < jobWrapper.object.params.length; i++) {
        let designJobParam = jobWrapper.object.params[i];
        if (designJobParam.paramVal.indexOf(oldFullName) == -1) continue;

        designJobParam.paramVal = Util.getInstance().rename(
          designJobParam.paramVal,
          oldFullNameRegexp,
          newFullName,
        );
      }
    }

    if (jobWrapper.hasOwnProperty("restJob")) {
      for (let i: number = 0; i < jobWrapper.object.parameters.length; i++) {
        var restJobParam = jobWrapper.object.parameters[i];
        if (restJobParam.paramVal.indexOf(oldFullName) != -1) {
          let val = jobWrapper.object.parameters[i].paramVal
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.parameters[i].paramVal = val;
        }
      }
      for (var i = 0; i < jobWrapper.object.parameters.length; i++) {
        let paramNm: any =
          jobWrapper.object.parameters[i].paramNm.toUpperCase();
        oldFullName = oldFullName.toUpperCase();
        newFullName = newFullName.toUpperCase();
        if (paramNm.indexOf(oldFullName) != -1) {
          let val: string = jobWrapper.object.parameters[i].paramNm.split("."); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          let str1: string = val[0].split(oldFullName).join(newFullName);
          let newStr = str1 + "." + val[1];
          jobWrapper.object.parameters[i].paramNm = newStr;
        }
      }
      for (let i = 0; i < jobWrapper.object.rest_Properties.length; i++) {
        let property_Cd = jobWrapper.object.rest_Properties[i].property_Cd;
        if (
          property_Cd == "BODY" ||
          property_Cd == "END_POINT_RELATIVE" ||
          property_Cd == "REST_WEBSERVICES_URL"
        ) {
          // oldFullName = oldFullName.toUpperCase();
          if (
            jobWrapper.object.rest_Properties[i].propertyVal.indexOf(
              oldFullName,
            ) != -1
          ) {
            let val = jobWrapper.object.rest_Properties[i].propertyVal
              .split(oldFullName)
              .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
            jobWrapper.object.rest_Properties[i].propertyVal = val;
          }
        }
      }
      for (
        let i: number = 0;
        i < jobWrapper.object.file_Properties.length;
        i++
      ) {
        let property_Cd = jobWrapper.object.file_Properties[i].property_Cd;
        if (
          property_Cd == "FILE_NAME" ||
          property_Cd == "FILE_NM_PREFIX" ||
          property_Cd == "FILE_NM_SUFFIX"
        ) {
          // oldFullName = oldFullName.toUpperCase();
          if (
            jobWrapper.object.file_Properties[i].propertyVal.indexOf(
              oldFullName,
            ) != -1
          ) {
            let val = jobWrapper.object.file_Properties[i].propertyVal
              .split(oldFullName)
              .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
            jobWrapper.object.file_Properties[i].propertyVal = val;
          }
        }
      }
      for (
        let i: number = 0;
        i < jobWrapper.object.decryption_Properties.length;
        i++
      ) {
        // oldFullName = oldFullName.toUpperCase();
        if (
          jobWrapper.object.decryption_Properties[i].propertyVal.indexOf(
            oldFullName,
          ) != -1
        ) {
          let val = jobWrapper.object.decryption_Properties[i].propertyVal
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.decryption_Properties[i].propertyVal = val;
        }
      }
      for (
        let i: number = 0;
        i < jobWrapper.object.pagination_Properties.length;
        i++
      ) {
        // oldFullName = oldFullName.toUpperCase();
        if (
          jobWrapper.object.pagination_Properties[i].propertyVal.indexOf(
            oldFullName,
          ) != -1
        ) {
          let val = jobWrapper.object.pagination_Properties[i].propertyVal
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.pagination_Properties[i].propertyVal = val;
        }
      }
      for (
        let i: number = 0;
        i < jobWrapper.object.param_Properties.length;
        i++
      ) {
        // oldFullName = oldFullName.toUpperCase();
        if (
          jobWrapper.object.param_Properties[i].propertyVal.indexOf(
            oldFullName,
          ) != -1
        ) {
          let val = jobWrapper.object.param_Properties[i].propertyVal
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.param_Properties[i].propertyVal = val;
        }
      }
      for (
        let i: number = 0;
        i < jobWrapper.object.reRun_Properties.length;
        i++
      ) {
        // oldFullName = oldFullName.toUpperCase();
        if (
          jobWrapper.object.reRun_Properties[i].propertyVal.indexOf(
            oldFullName,
          ) != -1
        ) {
          let val = jobWrapper.object.reRun_Properties[i].propertyVal
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.reRun_Properties[i].propertyVal = val;
        }
      }
      for (
        let i: number = 0;
        i < jobWrapper.object.header_Properties.length;
        i++
      ) {
        // oldFullName = oldFullName.toUpperCase();
        if (
          jobWrapper.object.header_Properties[i].propertyVal.indexOf(
            oldFullName,
          ) != -1
        ) {
          let val = jobWrapper.object.header_Properties[i].propertyVal
            .split(oldFullName)
            .join(newFullName); //jobWrapper.restJob.rest_Properties[i].propertyVal.replace( oldFullNameRegexp, newFullName );
          jobWrapper.object.header_Properties[i].propertyVal = val;
        }
      }
    }

    if (jobWrapper.hasOwnProperty("fileTransfer")) {
      for (
        let h: number = 0;
        h < jobWrapper.object.conn_Db_Obj_Lnks.length;
        h++
      ) {
        if (jobWrapper.object.conn_Db_Obj_Lnks[h].obj_Cd == "DOBJIS") {
          for (
            let i: number = 0;
            i < jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties.length;
            i++
          ) {
            let extractProperty =
              jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties[i];
            if (
              extractProperty.property_Cd == "LOCATION" ||
              extractProperty.property_Cd == "FILE_NAME"
            ) {
              if (extractProperty.propertyVal.indexOf(oldFullName) != -1) {
                jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties[
                  i
                ].propertyVal = Util.getInstance().rename(
                  extractProperty.propertyVal,
                  oldFullNameRegexp,
                  newFullName,
                );
              }
            }
          }
        }
        if (jobWrapper.object.conn_Db_Obj_Lnks[h].obj_Cd == "DOBJIT") {
          for (
            let i: number = 0;
            i < jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties.length;
            i++
          ) {
            let load_Propertiy =
              jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties[i];
            if (
              load_Propertiy.property_Cd == "LOCATION" ||
              load_Propertiy.property_Cd == "FILE_NAME" ||
              load_Propertiy.property_Cd == "FILE_NM_PREFIX" ||
              load_Propertiy.property_Cd == "FILE_NM_SUFFIX"
            ) {
              if (load_Propertiy.propertyVal.indexOf(oldFullName) != -1) {
                jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties[
                  i
                ].propertyVal = Util.getInstance().rename(
                  load_Propertiy.propertyVal,
                  oldFullNameRegexp,
                  newFullName,
                );
              }
            }
          }
        }
      }
    }
    if (jobWrapper.hasOwnProperty("office365")) {
      for (
        let i: number = 0;
        i < jobWrapper.object.column_Properties.length;
        i++
      ) {
        let columnProperty = jobWrapper.object.column_Properties[i];
        if (columnProperty.propertyVal.indexOf(oldFullName) != -1) {
          jobWrapper.object.column_Properties[i].propertyVal =
            Util.getInstance().rename(
              columnProperty.propertyVal,
              oldFullNameRegexp,
              newFullName,
            );
        }
      }
      for (
        let i: number = 0;
        i < jobWrapper.object.office_Properties.length;
        i++
      ) {
        let office_Property = jobWrapper.object.office_Properties[i];
        if (office_Property.propertyVal.indexOf(oldFullName) != -1) {
          jobWrapper.object.office_Properties[i].propertyVal =
            Util.getInstance().rename(
              office_Property.propertyVal,
              oldFullNameRegexp,
              newFullName,
            );
        }
      }

      for (
        let i: number = 0;
        i < jobWrapper.object.target_Properties.length;
        i++
      ) {
        let load_Propertiy = jobWrapper.object.target_Properties[i];
        if (load_Propertiy.propertyVal.indexOf(oldFullName) != -1) {
          jobWrapper.object.target_Properties[i].propertyVal =
            Util.getInstance().rename(
              load_Propertiy.propertyVal,
              oldFullNameRegexp,
              newFullName,
            );
        }
      }
    }

    if (jobWrapper.hasOwnProperty("kafkaConsumer")) {
      for (
        let i: number = 0;
        i < jobWrapper.object.column_Properties.length;
        i++
      ) {
        let columnProperty = jobWrapper.object.column_Properties[i];
        if (columnProperty.propertyVal.indexOf(oldFullName) != -1) {
          jobWrapper.object.column_Properties[i].propertyVal =
            Util.getInstance().rename(
              columnProperty.propertyVal,
              oldFullNameRegexp,
              newFullName,
            );
        }
      }
      for (
        let i: number = 0;
        i < jobWrapper.object.kafka_Consumer_Properties.length;
        i++
      ) {
        let kafkaconsumer_Property = jobWrapper.object._Properties[i];
        if (kafkaconsumer_Property.propertyVal.indexOf(oldFullName) != -1) {
          jobWrapper.object.kafka_Consumer_Properties[i].propertyVal =
            Util.getInstance().rename(
              kafkaconsumer_Property.propertyVal,
              oldFullNameRegexp,
              newFullName,
            );
        }
      }

      for (
        let i: number = 0;
        i < jobWrapper.object.target_Properties.length;
        i++
      ) {
        let load_Property = jobWrapper.object.target_Properties[i];
        if (load_Property.propertyVal.indexOf(oldFullName) != -1) {
          jobWrapper.object.target_Properties[i].propertyVal =
            Util.getInstance().rename(
              load_Property.propertyVal,
              oldFullNameRegexp,
              newFullName,
            );
        }
      }
    }

    if (jobWrapper.hasOwnProperty("gpsSubscriber")) {
      for ( let i: number = 0;i < jobWrapper.object.column_Properties.length;i++ ) {
        let columnProperty = jobWrapper.object.column_Properties[i];
        if (columnProperty.propertyVal.indexOf(oldFullName) != -1) {
          jobWrapper.object.column_Properties[i].propertyVal =
            Util.getInstance().rename(
              columnProperty.propertyVal,
              oldFullNameRegexp,
              newFullName,
            );
        }
      }
      for ( let i: number = 0;  i < jobWrapper.object.gps_Subscriber_Properties.length;i++ ) {
        let gpsSubscriber_Property = jobWrapper.object._Properties[i];
        if (gpsSubscriber_Property.propertyVal.indexOf(oldFullName) != -1) {
          jobWrapper.object.gpsSubscriber_Property [i].propertyVal =
            Util.getInstance().rename(
              gpsSubscriber_Property.propertyVal,
              oldFullNameRegexp,
              newFullName,
            );
        }
      }

      for (
        let i: number = 0;
        i < jobWrapper.object.target_Properties.length;
        i++
      ) {
        let load_Property = jobWrapper.object.target_Properties[i];
        if (load_Property.propertyVal.indexOf(oldFullName) != -1) {
          jobWrapper.object.target_Properties[i].propertyVal =
            Util.getInstance().rename(
              load_Property.propertyVal,
              oldFullNameRegexp,
              newFullName,
            );
        }
      }
    }

    //add by sharmi on 4-3-25
    if (jobWrapper.hasOwnProperty("jsonc")) {
      for (
        let i: number = 0;
        i < jobWrapper.object.column_Properties.length;
        i++
      ) {
        let columnProperty = jobWrapper.object.column_Properties[i];
        if (columnProperty.propertyVal.indexOf(oldFullName) != -1) {
          jobWrapper.object.column_Properties[i].propertyVal =
            Util.getInstance().rename(
              columnProperty.propertyVal,
              oldFullNameRegexp,
              newFullName,
            );
        }
      }
      for (
        let i: number = 0;
        i < jobWrapper.object.jsonC_Properties.length;
        i++
      ) {
        let jsonC_Property = jobWrapper.object.jsonC_Properties[i];
        if (jsonC_Property.propertyVal.indexOf(oldFullName) != -1) {
          jobWrapper.object.jsonC_Properties[i].propertyVal =
            Util.getInstance().rename(
              jsonC_Property.propertyVal,
              oldFullNameRegexp,
              newFullName,
            );
        }
      }

      for (
        let i: number = 0;
        i < jobWrapper.object.target_Properties.length;
        i++
      ) {
        let load_Propertiy = jobWrapper.object.target_Properties[i];
        if (load_Propertiy.propertyVal.indexOf(oldFullName) != -1) {
          jobWrapper.object.target_Properties[i].propertyVal =
            Util.getInstance().rename(
              load_Propertiy.propertyVal,
              oldFullNameRegexp,
              newFullName,
            );
        }
      }
    }

    // if (jobWrapper.hasOwnProperty('kafkaProducerJob')) {
    //     for (let h: number = 0; h < jobWrapper.object.conn_Db_Obj_Lnks.length; h++) {
    //         if (jobWrapper.object.conn_Db_Obj_Lnks[h].obj_Cd == "DOBJIS") {
    //             for (let i: number = 0; i < jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties.length; i++) {
    //                 let extractProperty = jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties[i];
    //                 if (extractProperty.propertyVal.indexOf(oldFullName) != -1) {
    //                     jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties[i].propertyVal = Util.getInstance().rename(extractProperty.propertyVal, oldFullNameRegexp, newFullName);
    //                 }
    //             }
    //         }
    //         if (jobWrapper.object.conn_Db_Obj_Lnks[h].obj_Cd == "DOBJIT") {
    //             for (let i: number = 0; i < jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties.length; i++) {
    //                 let load_Propertiy = jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties[i];
    //                 if (load_Propertiy.propertyVal.indexOf(oldFullName) != -1) {
    //                     jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties[i].propertyVal = Util.getInstance().rename(load_Propertiy.propertyVal, oldFullNameRegexp, newFullName);
    //                 }
    //             }
    //         }
    //     }
    // }

    if (jobWrapper.hasOwnProperty("mongoDB")) {
      for (
        let h: number = 0;
        h < jobWrapper.object.conn_Db_Obj_Lnks.length;
        h++
      ) {
        if (jobWrapper.object.conn_Db_Obj_Lnks[h].obj_Cd == "DOBJIS") {
          for (
            let i: number = 0;
            i < jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties.length;
            i++
          ) {
            let extractProperty =
              jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties[i];
            if (extractProperty.propertyVal.indexOf(oldFullName) != -1) {
              jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties[
                i
              ].propertyVal = Util.getInstance().rename(
                extractProperty.propertyVal,
                oldFullNameRegexp,
                newFullName,
              );
            }
          }
        }
        if (jobWrapper.object.conn_Db_Obj_Lnks[h].obj_Cd == "DOBJIT") {
          for (
            let i: number = 0;
            i < jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties.length;
            i++
          ) {
            let load_Propertiy =
              jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties[i];
            if (load_Propertiy.propertyVal.indexOf(oldFullName) != -1) {
              jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties[
                i
              ].propertyVal = Util.getInstance().rename(
                load_Propertiy.propertyVal,
                oldFullNameRegexp,
                newFullName,
              );
            }
          }
        }
      }
    }

    if (jobWrapper.hasOwnProperty("hbase")) {
      for (
        let h: number = 0;
        h < jobWrapper.object.conn_Db_Obj_Lnks.length;
        h++
      ) {
        if (jobWrapper.object.conn_Db_Obj_Lnks[h].obj_Cd == "DOBJIS") {
          for (
            let i: number = 0;
            i < jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties.length;
            i++
          ) {
            let extractProperty =
              jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties[i];
            if (extractProperty.propertyVal.indexOf(oldFullName) != -1) {
              jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties[
                i
              ].propertyVal = Util.getInstance().rename(
                extractProperty.propertyVal,
                oldFullNameRegexp,
                newFullName,
              );
            }
          }
        }
        if (jobWrapper.object.conn_Db_Obj_Lnks[h].obj_Cd == "DOBJIT") {
          for (
            let i: number = 0;
            i < jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties.length;
            i++
          ) {
            let load_Propertiy =
              jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties[i];
            if (load_Propertiy.propertyVal.indexOf(oldFullName) != -1) {
              jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties[
                i
              ].propertyVal = Util.getInstance().rename(
                load_Propertiy.propertyVal,
                oldFullNameRegexp,
                newFullName,
              );
            }
          }
        }
      }
    }

    if (jobWrapper.hasOwnProperty("gPS")) {
      for (
        let h: number = 0;
        h < jobWrapper.object.conn_Db_Obj_Lnks.length;
        h++
      ) {
        if (jobWrapper.object.conn_Db_Obj_Lnks[h].obj_Cd == "DOBJIS") {
          for (
            let i: number = 0;
            i < jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties.length;
            i++
          ) {
            let extractProperty =
              jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties[i];
            if (extractProperty.propertyVal.indexOf(oldFullName) != -1) {
              jobWrapper.object.conn_Db_Obj_Lnks[h].extract_Properties[
                i
              ].propertyVal = Util.getInstance().rename(
                extractProperty.propertyVal,
                oldFullNameRegexp,
                newFullName,
              );
            }
          }
        }
        if (jobWrapper.object.conn_Db_Obj_Lnks[h].obj_Cd == "DOBJIT") {
          for (
            let i: number = 0;
            i < jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties.length;
            i++
          ) {
            let load_Propertiy =
              jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties[i];
            if (load_Propertiy.propertyVal.indexOf(oldFullName) != -1) {
              jobWrapper.object.conn_Db_Obj_Lnks[h].load_Properties[
                i
              ].propertyVal = Util.getInstance().rename(
                load_Propertiy.propertyVal,
                oldFullNameRegexp,
                newFullName,
              );
            }
          }
        }
      }
    }
    jobWrapper.setChange_Ind();
  }

  toString(jobs: Array<any>): string {
    return "";
  }
}
